module.exports = __webpack_public_path__ + "static/media/icon1.98c80bad.png";